class NexitaConversionGuarantee extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-guarantee-open]');
    this.dialog = this.querySelector('[data-guarantee-dialog]');
    this.closeButton = this.querySelector('[data-guarantee-close]');

    if (!this.trigger || !this.dialog || !this.closeButton) return;

    this.handleOpen = () => {
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
      document.documentElement.classList.add('nexita-guarantee-open');
    };
    this.handleClose = () => this.dialog.close();
    this.handleBackdrop = (event) => {
      if (event.target === this.dialog) this.dialog.close();
    };
    this.handleDialogClose = () => document.documentElement.classList.remove('nexita-guarantee-open');

    this.trigger.addEventListener('click', this.handleOpen);
    this.closeButton.addEventListener('click', this.handleClose);
    this.dialog.addEventListener('click', this.handleBackdrop);
    this.dialog.addEventListener('close', this.handleDialogClose);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.handleOpen);
    this.closeButton?.removeEventListener('click', this.handleClose);
    this.dialog?.removeEventListener('click', this.handleBackdrop);
    this.dialog?.removeEventListener('close', this.handleDialogClose);
    document.documentElement.classList.remove('nexita-guarantee-open');
  }
}

if (!customElements.get('nexita-conversion-guarantee')) {
  customElements.define('nexita-conversion-guarantee', NexitaConversionGuarantee);
}
